export interface NavigatorLike {
  userAgent?: string;
  platform?: string;
  maxTouchPoints?: number;
  standalone?: boolean;
}

export interface WindowLike {
  matchMedia?: (query: string) => MediaQueryList;
  navigator?: NavigatorLike;
}

export function detectIsIOS(navigatorLike?: NavigatorLike): boolean {
  const nav =
    navigatorLike ?? (typeof navigator !== 'undefined' ? (navigator as NavigatorLike) : undefined);

  if (!nav) {
    return false;
  }

  const userAgent = nav.userAgent || '';
  const platform = nav.platform || '';
  const maxTouchPoints = typeof nav.maxTouchPoints === 'number' ? nav.maxTouchPoints : 0;

  return /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
}

export function isStandaloneDisplayMode(windowLike?: WindowLike): boolean {
  const win =
    windowLike ?? (typeof window !== 'undefined' ? (window as unknown as WindowLike) : undefined);

  if (!win) {
    return false;
  }

  const mediaMatches =
    typeof win.matchMedia === 'function' && win.matchMedia('(display-mode: standalone)').matches;
  const nav = win.navigator;

  return mediaMatches || Boolean(nav?.standalone);
}
